import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Info } from 'lucide-react';
import logoMark from '../assets/logo_mark.svg';

function NavItem({ to, icon: Icon, children }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        [
          'h-10 px-4 rounded-2xl border text-sm font-extrabold transition inline-flex items-center gap-2',
          isActive
            ? 'bg-blue-50 text-blue-700 border-blue-100'
            : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50',
        ].join(' ')
      }
    >
      <Icon size={18} />
      <span>{children}</span>
    </NavLink>
  );
}

export default function SiteHeader() {
  return (
    <header className="bg-blue-50 border-b border-blue-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-11 h-11 bg-[#213970] rounded-2xl flex items-center justify-center text-white shadow-sm flex-shrink-0">
            <img
              src={logoMark}
              alt="لوگوی کریدور هوشمند"
              className="w-7 h-7 select-none"
              draggable={false}
            />
          </div>
          <div className="min-w-0">
            <div className="text-sm sm:text-base font-black text-[#213970] truncate">کریدور هوشمند</div>
            <div className="text-[10px] text-gray-400 font-bold mt-0.5 truncate">
              شمال - جنوب | مدیریت لجستیک، تجارت و سرمایه‌گذاری
            </div>
          </div>
        </div>

        <nav className="flex items-center gap-2 flex-shrink-0">
          <NavItem to="/dashboard" icon={Home}>
            صفحه اصلی
          </NavItem>
          <NavItem to="/about" icon={Info}>
            درباره ما
          </NavItem>
        </nav>
      </div>
    </header>
  );
}

